export default "__VITE_ASSET__Dj0XNsX0__"